// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nocoupon-container {
  margin: 0 -20px 0 -20px;
}

.head-title {
  font-size: 28px;
  color: #0d2b38;
  padding: 0 40px 0 40px;
}

.head-para {
  padding: 0 40px 0 40px;
  font-size: 16px;
  font-weight: 600;
}

.container-one {
  margin-top: 30px;
  background: #e6faff;
  display: flex;
  flex-direction: row;
  width: 100%;
}
.container-one .section-para {
  flex: 1 1;
  display: flex;
  align-items: center;
  padding-left: 40px;
  font-size: 18px;
  font-weight: 500;
  color: #0d2b38;
}
.container-one .main-sub-text {
  align-items: center;
  justify-content: center;
  margin-top: 60px;
}
.container-one .termsLimit {
  padding-left: 40px;
  color: #3f3f3f;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
}
.container-one .noCoupon_img {
  flex: 1 1;
  width: 100px;
  height: 200px;
}

.main-sub-text,
.show-desktop {
  display: block;
  flex: 1 1;
}

.sub-text {
  padding-left: 40px;
  color: #3f3f3f;
  font-size: 14px;
  font-weight: 400;
}

.sub-text-mobile,
.hide-mobile {
  display: none;
}

.footer-text,
.footer-para {
  padding: 0 40px 0 40px;
}

.footer-text {
  font-size: 18px;
  font-weight: 500;
  color: #0d2b38;
  padding-top: 30px;
}

.footer-para {
  font-size: 16px;
  font-weight: 600;
  color: #4d4d4f;
}

.nocoupon-button {
  width: 300px;
  color: #0d2b38 !important;
  margin-left: 40px;
  margin-top: 20px;
}

@media only screen and (max-width: 576px) {
  .container-one {
    flex-direction: column;
    margin-top: 15px;
  }
  .container-one .section-para {
    margin: 0;
    padding: 0 40px 0 40px;
  }
  .container-one .noCoupon_img {
    width: 100%;
    height: 100%;
  }
  .sub-text {
    display: none;
  }
  .sub-text-mobile {
    margin-top: 10px;
    padding-left: 40px;
    color: #3f3f3f;
    font-size: 14px;
    font-weight: 400;
    display: block;
  }
  .show-desktop {
    display: none;
  }
  .hide-mobile {
    display: block;
    color: #3f3f3f;
    font-size: 14px;
    font-weight: 400;
  }
  .termsLimit {
    padding-left: 40px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/NoCoupon/NoCoupon.scss"],"names":[],"mappings":"AAAA;EACE,uBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,sBAAA;AACF;;AACA;EACE,sBAAA;EACA,eAAA;EACA,gBAAA;AAEF;;AAAA;EACE,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AAGF;AAFE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AAIJ;AAFE;EACE,mBAAA;EACA,uBAAA;EACA,gBAAA;AAIJ;AAFE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;AAIJ;AAFE;EACE,SAAA;EACA,YAAA;EACA,aAAA;AAIJ;;AADA;;EAEE,cAAA;EACA,SAAA;AAIF;;AADA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAIF;;AAFA;;EAEE,aAAA;AAKF;;AAHA;;EAEE,sBAAA;AAMF;;AAJA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;AAOF;;AALA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;AAQF;;AANA;EACE,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AASF;;AAPA;EACE;IACE,sBAAA;IACA,gBAAA;EAUF;EATE;IACE,SAAA;IACA,sBAAA;EAWJ;EATE;IACE,WAAA;IACA,YAAA;EAWJ;EARA;IACE,aAAA;EAUF;EARA;IACE,gBAAA;IACA,kBAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;IACA,cAAA;EAUF;EARA;IACE,aAAA;EAUF;EARA;IACE,cAAA;IACA,cAAA;IACA,eAAA;IACA,gBAAA;EAUF;EARA;IACE,6BAAA;EAUF;AACF","sourcesContent":[".nocoupon-container {\n  margin: 0 -20px 0 -20px;\n}\n\n.head-title {\n  font-size: 28px;\n  color: #0d2b38;\n  padding: 0 40px 0 40px;\n}\n.head-para {\n  padding: 0 40px 0 40px;\n  font-size: 16px;\n  font-weight: 600;\n}\n.container-one {\n  margin-top: 30px;\n  background: #e6faff;\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  .section-para {\n    flex: 1;\n    display: flex;\n    align-items: center;\n    padding-left: 40px;\n    font-size: 18px;\n    font-weight: 500;\n    color: #0d2b38;\n  }\n  .main-sub-text {\n    align-items: center;\n    justify-content: center;\n    margin-top: 60px;\n  }\n  .termsLimit {\n    padding-left: 40px;\n    color: #3f3f3f;\n    font-size: 14px;\n    font-weight: 400;\n    width: 100%;\n  }\n  .noCoupon_img {\n    flex: 1;\n    width: 100px;\n    height: 200px;\n  }\n}\n.main-sub-text,\n.show-desktop {\n  display: block;\n  flex: 1;\n}\n\n.sub-text {\n  padding-left: 40px;\n  color: #3f3f3f;\n  font-size: 14px;\n  font-weight: 400;\n}\n.sub-text-mobile,\n.hide-mobile {\n  display: none;\n}\n.footer-text,\n.footer-para {\n  padding: 0 40px 0 40px;\n}\n.footer-text {\n  font-size: 18px;\n  font-weight: 500;\n  color: #0d2b38;\n  padding-top: 30px;\n}\n.footer-para {\n  font-size: 16px;\n  font-weight: 600;\n  color: #4d4d4f;\n}\n.nocoupon-button {\n  width: 300px;\n  color: #0d2b38 !important;\n  margin-left: 40px;\n  margin-top: 20px;\n}\n@media only screen and (max-width: 576px) {\n  .container-one {\n    flex-direction: column;\n    margin-top: 15px;\n    .section-para {\n      margin: 0;\n      padding: 0 40px 0 40px;\n    }\n    .noCoupon_img {\n      width: 100%;\n      height: 100%;\n    }\n  }\n  .sub-text {\n    display: none;\n  }\n  .sub-text-mobile {\n    margin-top: 10px;\n    padding-left: 40px;\n    color: #3f3f3f;\n    font-size: 14px;\n    font-weight: 400;\n    display: block;\n  }\n  .show-desktop {\n    display: none;\n  }\n  .hide-mobile {\n    display: block;\n    color: #3f3f3f;\n    font-size: 14px;\n    font-weight: 400;\n  }\n  .termsLimit {\n    padding-left: 40px !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
